// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"79fd138c","289":"5af7dfbb","542":"d5a0fca8","545":"d7357677","710":"88c2a2fc","787":"7570abbf","844":"d7723784"}[chunkId] + ".chunk.js";
};